import React, { Dispatch, SetStateAction, useCallback } from 'react';
import DataList from '../common/list/DataList';
import KeyOrganizationsTitle from './KeyOrganizationsTitle';
import { useSaveKeyOrganizations } from './helpers/productionApi';
import { getKeyOrganizationInput, ProductionOrganizationInfoWithKey } from './helpers/organizationUtils';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { ProductionOrganizationInfo } from 'sr-types/lib/production/v1/graphql';

type OrganizationSavingState = {
    id: string;
    isSaving: boolean;
    productionRoles: any[];
};

type KeyOrgDataListProps = {
    isOrganizationSaving: OrganizationSavingState;
    setIsOrganizationSaving: Dispatch<SetStateAction<OrganizationSavingState>>;
    productionId: string;
    client: ApolloClient<NormalizedCacheObject>;
    handleAfterRefetch: () => void;
    filteredOrgList: ProductionOrganizationInfoWithKey[];
    orgWithKey: ProductionOrganizationInfoWithKey[];
    keyOrganizations: ProductionOrganizationInfo[];
    setViewState?: (viewState) => void;
};

export default ({
    isOrganizationSaving,
    setIsOrganizationSaving,
    productionId,
    handleAfterRefetch,
    filteredOrgList,
    orgWithKey,
    setViewState,
    keyOrganizations
}: KeyOrgDataListProps) => {
    const { saveKeyOrganization } = useSaveKeyOrganizations();

    const handleMarkingUnmarking = (org: ProductionOrganizationInfoWithKey, marking: boolean) => {
        setIsOrganizationSaving({
            id: org.organizationReference.id,
            isSaving: true,
            productionRoles: org.productionRoles
        });
        const newKeyOrganizations = marking
            ? getKeyOrganizationInput(orgWithKey, org, undefined)
            : getKeyOrganizationInput(orgWithKey, undefined, org);
        setViewState((prev) => ({
            ...prev,
            keyOrganizations: newKeyOrganizations
        }));
        saveKeyOrganization(productionId, newKeyOrganizations, true)
            .catch(() => {
                setViewState((prev) => ({
                    ...prev,
                    keyOrganizations
                }));
            })
            .finally(() => handleAfterRefetch());
    };

    const ItemRenderer = useCallback(
        (props) => {
            return (
                <KeyOrganizationsTitle
                    {...props}
                    isLoading={isOrganizationSaving}
                    onMarkClick={(org) => handleMarkingUnmarking(org, true)}
                    onUnmarkClick={(org) => handleMarkingUnmarking(org, false)}
                />
            );
        },
        [isOrganizationSaving]
    );

    return <DataList items={filteredOrgList} onClick={undefined} disableRipple ItemRenderer={ItemRenderer} />;
};
